// Pause a product gallery video when its slide leaves view (arrow, swipe or page scroll).
(function () {
  if (!('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting && !entry.target.paused) entry.target.pause();
    });
  }, { threshold: 0.5 });
  var watch = function () {
    document.querySelectorAll('.c-prod-gallery video').forEach(function (video) {
      if (video.dataset.pauseWatch) return;
      video.dataset.pauseWatch = '1';
      io.observe(video);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
})();
